import { render, staticRenderFns } from "./CustomBarChart.vue?vue&type=template&id=758b39dd&scoped=true&"
import script from "./CustomBarChart.vue?vue&type=script&lang=ts&"
export * from "./CustomBarChart.vue?vue&type=script&lang=ts&"
import style0 from "./CustomBarChart.vue?vue&type=style&index=0&id=758b39dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758b39dd",
  null
  
)

export default component.exports